import { render, staticRenderFns } from "./ChatChatShareMsg.vue?vue&type=template&id=79ec2fc0&"
import script from "./ChatChatShareMsg.vue?vue&type=script&lang=js&"
export * from "./ChatChatShareMsg.vue?vue&type=script&lang=js&"
import style0 from "./ChatChatShareMsg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports